"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = _interopRequireDefault(require("./context"));

var _subscribeHelper = require("./helpers/subscribe-helper");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background-color: green;\n  z-index: 1300;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LocalizeDebugModeTarget = _styledComponents["default"].span(_templateObject());

var ClickArea = _styledComponents["default"].div(_templateObject2());

var getTranslatedText = function getTranslatedText(localize, message, values) {
  var localized = message;

  if (typeof localize === 'function') {
    localized = localize(message, values);

    if (localized !== null && (0, _typeof2["default"])(localized) === 'object') {
      var index = 0;

      if (localized.constructor === Array) {
        localized = localized.map(function (i) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            key: index++
          }, i);
        });
      }
    }
  }

  return localized;
};
/**
 * Text component  - this will render the text, using the provided "message"
 * TextComponent
 * @param message - key of the translation key
 * @param values - array of values that can de used during string format
 */


var TextComponent = function TextComponent(_ref) {
  var message = _ref.message,
      values = _ref.values,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["message", "values"]);

  var _useContext = (0, _react.useContext)(_context["default"]),
      localize = _useContext.localize,
      _localizeDebug = _useContext._localizeDebug;

  var _useState = (0, _react.useState)(getTranslatedText(localize, message, values)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      localized = _useState2[0],
      setLocalized = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      postMessageHandler = _useState4[0],
      setPostMessageHandler = _useState4[1];

  var textSpan = (0, _react.useRef)(); // Unsubscribe post message handler on unmount

  (0, _react.useEffect)(function () {
    return function () {
      return (0, _subscribeHelper.unSubscribeToTranslationChange)(postMessageHandler, setPostMessageHandler);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setLocalized(getTranslatedText(localize, message, values));
  }, [message, values]); // OnClick only used during inline editing checks if you clicks inside the green box

  var onClick = function onClick(proxy) {
    if (_localizeDebug) {
      proxy.preventDefault();
      proxy.stopPropagation();
      setLocalized(message, values);
      window.localizationPopup.open(message, localized);
      (0, _subscribeHelper.subscribeToTranslationChange)(message, textSpan, postMessageHandler, setPostMessageHandler);
    }
  };

  if (_localizeDebug) {
    rest['data-original-message'] = message;
    return /*#__PURE__*/_react["default"].createElement(LocalizeDebugModeTarget, (0, _extends2["default"])({
      ref: textSpan
    }, rest), /*#__PURE__*/_react["default"].createElement(ClickArea, {
      onClick: onClick
    }), localized);
  }

  return /*#__PURE__*/_react["default"].createElement("span", rest, localized);
};

TextComponent.propTypes = {
  message: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object])
};
var _default = TextComponent;
exports["default"] = _default;